class UiUtils {
    // static desktopScreenSize = 1024;
    static mobileMediaQuery = "(max-width: 1023px)";
    static isMobileCachedValue;


    static isMobile() {
        if(!this.isMobileCachedValue){
            // this.isMobileCachedValue = $(window).width() <= this.desktopScreenSize;
          this.isMobileCachedValue = window.matchMedia(this.mobileMediaQuery).matches;
        }

        return this.isMobileCachedValue;
    }
}

export {UiUtils};